import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { from, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private router: Router, private route: ActivatedRoute) {}

  /**
   * Navigate to a URL while preserving the current scroll position and optionally including current route's query parameters
   *
   * @param url - The target route
   * @param takeRouteParams - Boolean flag to include current route's query parameters
   * @param extraQueryParams - Additional query parameters for the navigation
   */
  navigatePreservingScroll(url: string, takeRouteParams = true, extraQueryParams: Params = {}): Observable<boolean> {
    const currentScrollHeight = window.scrollY;

    // merge existing route's queryParams if `takeRouteParams` is true
    const queryParams = takeRouteParams
      ? { ...this.route.snapshot.queryParams, ...extraQueryParams }
      : { ...extraQueryParams };

    const fragment = this.route.snapshot.fragment;
    return from(this.router.navigate(url ? [url] : [], { queryParams, fragment }))
      .pipe(
        first(),
        tap(() => window.scrollTo({ top: currentScrollHeight })), // restore the scroll position after navigation
      );
  }
}
